export default __webpack_public_path__ + "ce3f777b43bf21b7cce892fba94f14b9.png";